export default "__VITE_ASSET__mv1cKh2N__"